export default __webpack_public_path__ + "767230091ce2e48b7d6355a86d14e881.otf";